import { detalheTooltip, SIMULACAO_TIP_BADGE } from "@/modules/recursos/simulacao";
import type { SimulacaoTooltipProps, SimulacaoTooltipViewModel } from "./types-simulacao-tooltip";

export function useSimulacaoTooltip({ marca }: SimulacaoTooltipProps): SimulacaoTooltipViewModel {
  return { ...detalheTooltip(marca), selo: SIMULACAO_TIP_BADGE };
}
